module.exports = __webpack_public_path__ + "static/kian-1b36ce013c53e844a50cd66a72efd9b5.jpg";